// ─────────────────────────────────────────────────────────────────────────────
// i18n/index.ts – vue-i18n v11 Setup
// Unterstützte Sprachen: de (Standard), fr, it, en, es, pt
// Sprachauswahl wird in localStorage gespeichert.
// ─────────────────────────────────────────────────────────────────────────────

import { createI18n } from 'vue-i18n';
import de from './locales/de';
import en from './locales/en';
import fr from './locales/fr';
import it from './locales/it';
import es from './locales/es';
import pt from './locales/pt';

export type SupportedLocale = 'de' | 'fr' | 'it' | 'en' | 'es' | 'pt';

export const SUPPORTED_LOCALES: { code: SupportedLocale; flag: string; label: string }[] = [
  { code: 'de', flag: '🇩🇪', label: 'Deutsch'   },
  { code: 'fr', flag: '🇫🇷', label: 'Français'  },
  { code: 'it', flag: '🇮🇹', label: 'Italiano'  },
  { code: 'en', flag: '🇬🇧', label: 'English'   },
  { code: 'es', flag: '🇪🇸', label: 'Español'   },
  { code: 'pt', flag: '🇵🇹', label: 'Português' },
];

const STORAGE_KEY = 'Printerqueue-lang';  // Schluessel bleibt betrieblich (Sprachwahl der Nutzer); frueher mit dreifachem ue geschrieben

function getSavedLocale(): SupportedLocale {
  const saved = localStorage.getItem(STORAGE_KEY) as SupportedLocale | null;
  if (saved && SUPPORTED_LOCALES.some(l => l.code === saved)) return saved;
  // Fallback: Browsersprache erkennen
  const browser = navigator.language.slice(0, 2) as SupportedLocale;
  if (SUPPORTED_LOCALES.some(l => l.code === browser)) return browser;
  return 'de'; // Immer Deutsch als letzter Fallback
}

export const i18n = createI18n({
  legacy:        false,        // Composition API Modus
  locale:        getSavedLocale(),
  fallbackLocale:'de',
  messages: { de, fr, it, en, es, pt },
});

/** Sprache wechseln und in localStorage speichern */
export function setLocale(locale: SupportedLocale) {
  (i18n.global.locale as any).value = locale;
  localStorage.setItem(STORAGE_KEY, locale);
  document.documentElement.lang = locale;
}
